import {
  Box,
  Table,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
  Flex,
  IconButton,
  Avatar,
  Wrap,
  WrapItem,
  Icon,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import {
  SortOrder,
  useDeleteContentMutation,
  useContentsQuery,
  ContentType,
  MediaType,
} from "../../generated/graphql";
import {
  FcRefresh,
  FcPlus,
  FcEditImage,
  FcUndo,
  FcStart,
  FcApproval,
  FcCancel,
  FcNumericalSorting12,
} from "react-icons/fc";
import DeleteItem from "../../components/delete/DeleteItem";
import Loading from "../../components/loading/Loading";
import Error from "../../components/error/Error";
import PageLayout from "../../components/ui/PageLayout";
import { Link } from "react-router-dom";
import Description from "../../components/description/Description";

const All = () => {
  const params = useParams<{
    id: string;
    field: "page";
  }>();
  const [deleteCurrency] = useDeleteContentMutation();

  const { loading, error, data, refetch } = useContentsQuery({
    variables: {
      where: {
        [params.field!]: {
          is: {
            id: {
              equals: params.id,
            },
          },
        },
      },
      orderBy: {
        order: SortOrder.asc,
      },
    },
    fetchPolicy: "network-only",
  });
  if (loading) {
    return <Loading />;
  }
  if (error) {
    return (
      <Box>
        {error.message} <Error />
      </Box>
    );
  }

  const handleDelete = async (id: string) => {
    try {
      await deleteCurrency({
        variables: {
          where: {
            id,
          },
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <PageLayout>
      <Flex
        mb={6}
        justifyContent={"space-between"}
        alignItems="center"
        bgColor={"gray.100"}
        padding={2}
        rounded="md"
      >
        <Box fontSize={"18px"} fontWeight="bold">
          Contents List
        </Box>
        <Flex experimental_spaceX={4}>
          <IconButton
            icon={<FcUndo />}
            aria-label="Go Back"
            as={Link}
            to={`/${params.field}`}
          />
          <IconButton
            to={`/content/${params.field}/${params.id}/order`}
            as={Link}
            icon={<FcNumericalSorting12 fontSize="24px" />}
            aria-label="Order"
            onClick={() => refetch()}
          />
          <IconButton
            icon={<FcRefresh />}
            aria-label="Refetch Query"
            onClick={() => refetch()}
          />
          <IconButton
            to={`/content/${params.field}/${params.id}/create`}
            as={Link}
            icon={<FcPlus />}
            aria-label="Add Item"
            onClick={() => refetch()}
          />
        </Flex>
      </Flex>
      <Table>
        <Thead>
          <Tr>
            <Th>#</Th>
            <Th>Content</Th>
            <Th textAlign={"center"}>Content Type</Th>
            <Th textAlign={"center"}>Media Type</Th>
            <Th textAlign={"center"}>Web</Th>
            <Th textAlign={"center"}>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.contents.map((content, i) => {
            return (
              <Tr key={i}>
                <Td>{i + 1}</Td>
                <Td maxWidth={"300px"}>
                  {content.contentType === ContentType.IMAGE && (
                    <Box py={2}>
                      <Wrap>
                        {content.photos.map((p, i) => (
                          <WrapItem key={i}>
                            <Avatar
                              size={"sm"}
                              src={`${process.env.REACT_APP_CDN}thumbs/${p}`}
                            />
                          </WrapItem>
                        ))}
                      </Wrap>

                      {(content.mediaType === MediaType.SIDEBYSIDE ||
                        content.mediaType === MediaType.NOIMAGE) && (
                        <Box mt={3}>
                          <Description
                            descriptions={content.descriptions}
                            field={`content`}
                            id={content.id}
                            refetch={refetch}
                          />
                        </Box>
                      )}
                    </Box>
                  )}

                  {content.contentType === ContentType.VIDEO && content.video && (
                    <Flex>
                      <a href={content.video} target="_blank" rel="noreferrer">
                        <Icon as={FcStart} fontSize={"20px"} mr={2} />
                      </a>
                      {content.video.replace(/.+\/\/|www.|\..+/g, "").toUpperCase()} Video
                    </Flex>
                  )}
                  <Box mt={6}>
                    <Description
                      descriptions={content.descriptions}
                      field={`content`}
                      id={content.id}
                      refetch={refetch}
                    />
                  </Box>
                </Td>
                <Td textAlign={"center"}>{content.contentType}</Td>
                <Td textAlign={"center"}>
                  {content.contentType === ContentType.IMAGE ? content.mediaType : "-"}
                </Td>

                <Td textAlign={"center"}>
                  {content.showOnWeb ? (
                    <IconButton aria-label="Change Status" icon={<FcApproval />} />
                  ) : (
                    <IconButton aria-label="Change Status" icon={<FcCancel />} />
                  )}
                </Td>

                <Td>
                  <Flex justifyContent={"center"}>
                    {content.contentType !== ContentType.TEXT && (
                      <Box mx={2}>
                        <IconButton
                          aria-label="Edit"
                          icon={<FcEditImage />}
                          as={Link}
                          to={`/content/${params.field}/${params.id}/update/${content.id}`}
                        />
                      </Box>
                    )}
                    <Box mx={2}>
                      <DeleteItem
                        id={content.id}
                        refetch={refetch}
                        title={`${
                          content.contentType === ContentType.TEXT
                            ? content.descriptions[0].title
                            : "Content"
                        }`}
                        handleDelete={handleDelete}
                      />
                    </Box>
                  </Flex>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </PageLayout>
  );
};

export default All;
